// extracted by mini-css-extract-plugin
export default {"title_container":"Title_title_container__R4AuS","title":"Title_title__sT6ci"};